import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CardApi from "../../apis/card.api";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import TopPageBack from "../../components/TopPageBack";
import { ROUTE_PATHS } from "../../constants/Router";
import useAuth from "../../hooks/useAuth";
import AppUtils from "../../utils";
import formatDateToKorean from "../../utils/formatDateToKorean";

const CardManage = () => {
  const [disabledCardManage, setDisabledCardManage] = useState(false);
  const location = useLocation();
  const state = location.state;
  const navigate = useNavigate();
  const textColor = state?.has_changed ? "text-[#B7BDCA]" : "text-darkblue";
  const { ceoInfo } = useAuth();
  const [cardInfo, seCardInfo] = useState();

  const getCardManage = async () => {
    if (ceoInfo?.shop_idx) {
      if (state?.has_changed) {
        const res = await CardApi.getChanged(ceoInfo?.shop_idx);
        if (res.data.data) {
          seCardInfo(res.data.data);
        } else {
          navigate(ROUTE_PATHS.HistoryPayment);
        }
      } else {
        const res = await CardApi.get(ceoInfo?.shop_idx);
        if (res.data.data) {
          seCardInfo(res.data.data);
        } else {
          navigate(ROUTE_PATHS.HistoryPayment);
        }
      }
    }
  };

  useEffect(() => {
    getCardManage();
  }, [state?.has_changed]);

  useEffect(() => {
    if (cardInfo && cardInfo.has_changed) {
      setDisabledCardManage(true);
    } else {
      setDisabledCardManage(false);
    }
  }, [cardInfo]);

  return (
    <div>
      <TopPageBack>
        <b>납부 관리</b>
      </TopPageBack>
      <div className="mt-4 mx-5 overflow-hidden">
        <div className="text-22 text-darkblue font-bold">
          {state?.has_changed ? (
            <>
              <div>계좌 변경 신청이 접수되어</div>
              <div>처리중이에요.</div>
            </>
          ) : (
            <>
              <div>최근 및 예정된 납부 정보와</div>
              <div>이체 정보를 확인해 보세요.</div>
            </>
          )}
        </div>

        {
          state?.has_changed && (
          <div className="pt-3">
            <span className="font-normal size-[15px] text-[#111B48]">최대 3영업일 이후에 결과를 확인할 수 있어요.</span>
          </div>
          )
        }

        <div className="review-card2 py-4 mt-6 flex flex-col relative">
          <div className="flex flex-col gap-2">
            <div className="text-lg font-bold mb-1">납부 정보</div>
            <div className="bg-light-aqua2 p-4 rounded-lg ">
              <div className="mb-8">
                <div className="text-15 text-darkblue mb-2">최근 납부 금액</div>
                <div className="text-base font-bold text-darkblue">
                  {AppUtils.renderNumber(cardInfo?.recent_amount, true)}원
                  {cardInfo?.recent_payment_dt && (
                    <span className="font-normal">
                      ({AppUtils.formatToKoreaDate(cardInfo?.recent_payment_dt)}
                      )
                    </span>
                  )}
                </div>
              </div>
              <div>
                <div className="text-base text-darkblue mb-2">
                  납부 예정 금액
                </div>
                <div className="text-base font-bold text-darkblue">
                  {AppUtils.renderNumber(cardInfo?.service_amount, true)}원
                  {cardInfo?.service_payment_dt && (
                    <span className="font-normal">
                      (
                      {AppUtils.formatToKoreaDate(cardInfo?.service_payment_dt)}
                      )
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="review-card2 py-4 mt-6 flex flex-col">
          <div className={`flex flex-col gap-2 ${textColor}`}>
            <div className="text-lg font-bold mb-1">
              자동이체 및 예금주 정보
            </div>
            <div className="bg-light-aqua2 p-4 rounded-lg ">
              <div className="mb-8">
                <div className={`text-15 ${textColor} mb-2`}>은행</div>
                <div className={`text-base font-bold ${textColor}`}>
                  {state?.has_changed
                    ? cardInfo?.bank_name_after
                    : cardInfo?.bank_name}
                </div>
              </div>
              <div className="mb-8">
                <div className={`text-15 ${textColor} mb-2`}>계좌번호</div>
                <div className={`text-base font-bold ${textColor}`}>
                  {state?.has_changed
                    ? cardInfo?.account_no_after
                    : cardInfo?.account_no}
                </div>
              </div>
              <div className="mb-8">
                <div className={`text-15 ${textColor} mb-2`}>예금주</div>
                <div className={`text-base font-bold ${textColor}`}>
                  {state?.has_changed
                    ? cardInfo?.account_name_after
                    : cardInfo?.account_name}
                </div>
              </div>
              <div className="mb-8">
                <div className={`text-15 ${textColor} mb-2`}>예금주 휴대폰</div>
                <div className={`text-base font-bold ${textColor}`}>
                  {AppUtils.convertToKoreaPhoneNumber(
                    state?.has_changed
                      ? cardInfo?.account_phone_no_after
                      : cardInfo?.account_phone_no
                  )}
                </div>
              </div>
              <div>
                <div className={`text-15 ${textColor} mb-2`}>
                  예금주 생년월일
                </div>
                <div className={`text-base font-bold ${textColor}`}>
                  {state?.has_changed
                    ? cardInfo?.account_jumin_biz_no_after
                    : cardInfo?.account_jumin_biz_no}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="review-card2 py-4 mt-6 flex flex-col">
          <div className={`flex flex-col gap-2 ${textColor}`}>
            <div className="text-lg font-bold mb-1">신청자 정보</div>
            <div className="bg-light-aqua2 p-4 rounded-lg ">
              <div className="mb-8">
                <div className={`text-15 ${textColor} mb-2`}>신청자</div>
                <div className={`text-base font-bold ${textColor}`}>
                  {state?.has_changed
                    ? cardInfo?.apply_name_after
                    : cardInfo?.apply_name}
                </div>
              </div>
              <div className="mb-8">
                <div className={`text-15 ${textColor} mb-2`}>신청자 휴대폰</div>
                <div className={`text-base font-bold ${textColor}`}>
                  {AppUtils.convertToKoreaPhoneNumber(
                    state?.has_changed
                      ? cardInfo?.apply_phone_no_after
                      : cardInfo?.apply_phone_no
                  )}
                </div>
              </div>
              <div>
                <div className={`text-15 ${textColor} mb-2`}>
                  예금주와의 관계
                </div>
                <div className={`text-base font-bold ${textColor}`}>
                  {state?.has_changed
                    ? cardInfo?.account_relation_after
                    : cardInfo?.account_relation}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Temporarily hide this function bc client request */}               
        {/* {disabledCardManage ? (
          !state?.has_changed && (
            <SolidBlueBtn
              className="w-full mt-5 mb-3"
              onClick={() =>
                navigate(ROUTE_PATHS.CardManage, {
                  state: {
                    has_changed: disabledCardManage,
                  },
                })
              }
            >
              변경 신청서 보기
            </SolidBlueBtn>
          )
        ) : state?.has_changed ? null : (
          <SolidBlueBtn
            className="w-full mt-5 mb-3"
            onClick={() =>
              navigate(ROUTE_PATHS.EditCardManage, {
                state: {
                  has_changed: false,
                  cardInfo,
                },
              })
            }
          >
            계좌 변경 신청
          </SolidBlueBtn>
        )} */}
      </div>
    </div>
  );
};

export default CardManage;
